import React from 'react';
import { StarIcon } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Mariana López',
    age: 34,
    city: 'Córdoba',
    text: 'Finalmente entendí por qué mis clientes volvían con el mismo dolor. Ahora trabajo la causa real y los resultados son increíbles.'
  }, {
    name: 'Diego Fernández',
    age: 42,
    city: 'Rosario',
    text: 'Dupliqué mi retención de clientes en solo 2 meses. El sistema es claro, práctico y realmente funciona.'
  }, {
    name: 'Lucía Martínez',
    age: 29,
    city: 'Buenos Aires',
    text: 'Ahora cobro lo que realmente valgo y mis clientes están felices de pagarlo. Me siento mucho más segura en cada sesión.'
  }, {
    name: 'Sebastián Ruiz',
    age: 38,
    city: 'Mendoza',
    text: 'Las recomendaciones no paran de llegar. Pasé de tener agenda vacía a estar completo por semanas.'
  }, {
    name: 'Carolina Gómez',
    age: 45,
    city: 'La Plata',
    text: 'Este sistema estructurado cambió completamente mi práctica. Ya no improviso, tengo un método claro que me da resultados consistentes.'
  }];
  return <section className="w-full px-4 py-10 md:py-16 bg-[#0a0f1a]" data-id="element-166">
      <div className="max-w-3xl mx-auto" data-id="element-167">
        <h2 className="text-2xl md:text-3xl font-bold text-[#D4A843] mb-6 text-center" data-id="element-168">
          Lo que dicen otros terapeutas
        </h2>

        <div className="space-y-4" data-id="element-169">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-[#050810] border border-[#D4A843]/30 p-4 rounded-lg" data-id="element-170">
              <div className="flex items-center gap-2 mb-2" data-id="element-171">
                <div className="flex gap-0.5" data-id="element-172">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-[#D4A843] text-[#D4A843]" data-id="element-173" />)}
                </div>
                <span className="text-white text-sm font-semibold" data-id="element-174">
                  {testimonial.name}, {testimonial.age}
                </span>
                <span className="text-gray-500 text-xs" data-id="element-175">
                  — {testimonial.city}
                </span>
              </div>
              <p className="text-sm text-gray-300 italic" data-id="element-176">
                "{testimonial.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}